gsap.registerPlugin(ScrollTrigger);

class HorizontalScrollController {
    constructor(containerSelector, menueItemSelector, sectionSelector, pinScrolltrigger) {
        this.containerSelector = containerSelector;
        this.menueItemSelector = menueItemSelector;
        this.sectionSelector = sectionSelector;
        this.pinScrolltrigger = pinScrolltrigger;

        this.pinWrap = document.querySelector(this.containerSelector);
        this.scrollingContainer = this.pinWrap;

        this.scrollingContainer = this.pinWrap;
        this.menueItems = Array.from(document.querySelectorAll(this.menueItemSelector));
        this.sections = gsap.utils.toArray(this.sectionSelector);
        this.sectionsMap = new Map();
        this.itemsMap = new Map();

        // this.horizontalScrollLength = 0;

        this.setupSections();
        this.setupMenueClick();

        if (ScrollTrigger.isTouch === 1) {
            ScrollTrigger.normalizeScroll(true);
        }
    }

    initHorizontalScroll() {
        return new Promise((resolve, reject) => {
            console.log('this.pinWrap', this.pinWrap)
            if (this.pinWrap != null) {
                // initHorizontalScroll must wait to send a resolve until setupHorizontalScroll is done
                this.setupHorizontalScroll().then(() => {
                    window.addEventListener("resize", () => {
                        this.refresh();
                    });
                    resolve();
                });
            } else {
                // reject(new Error("pinWrap is null"));
                resolve();
            }
        });
    }

    // vermeidet Lücken bei der Grössenänderung
    refresh() {
        this.setHorizontalScrollLength();
        ScrollTrigger.refresh();
    }
    get horizontalScrollLength() {
        if (this.pinWrap != null) {
            return this.pinWrap.offsetWidth - window.innerWidth;
        } else {
            return 0
        }
    }

    setupHorizontalScroll() {
        return new Promise((resolve, reject) => {
            try {
                this.horizontalScrollTimeline = gsap.timeline({
                    scrollTrigger: {
                        id: 'slider',
                        trigger: this.containerSelector,
                        start: "top top",
                        end: () => `+=${this.pinWrap.offsetWidth - window.innerWidth}`,
                        pin: this.pinScrolltrigger,
                        invalidateOnRefresh: true,
                        scrub: true,
                        pinSpacing: true,
                        onUpdate: self => {
                            const activeMenueItemSelector = self.progress === 1 ? `${this.menueItemSelector}--entstehung` : `${this.menueItemSelector}--konzept`;
                            const menueItemElement = document.querySelector(activeMenueItemSelector);
                            if (menueItemElement) {
                                this.setActiveMenueItem(menueItemElement);
                            }
                        }
                    }
                });

                this.horizontalScrollTimeline.to(this.scrollingContainer, {
                    x: () => (this.pinWrap.offsetWidth - window.innerWidth) * -1,
                    ease: 'none',
                });

                // this.setHorizontalScrollLength();
                // console.log('setupHorizontalScroll fertig');
                resolve();
            } catch (error) {
                reject(error);
            }
        });
    }

    // Erstellt eine Map aus je section und Untermenüpunkt
    // Legt für alle sections einen Scrolltrigger an, der den zugehörigen Menüpunkt aktiv setzt
    setupSections() {
        this.sections.forEach((section, index) => {
            this.sectionsMap.set(section, this.menueItems[index]);
            this.itemsMap.set(this.menueItems[index], section);
        });

        this.sections.forEach((section, i) => {
            ScrollTrigger.create({
                trigger: section,
                start: "top center",
                end: "Top center",
                onEnter: () => {
                    if (!section.matches(this.sectionSelector)) return;
                    this.setActiveMenueItem(this.sectionsMap.get(section));
                },
                onLeaveBack: () => {
                    if (!section.matches(this.sectionSelector)) return;
                    this.setActiveMenueItem(this.sectionsMap.get(this.sections[i - 1]));
                }
            });
        });
    }

    setupMenueClick() {
        this.menueItems.forEach((item) => {
            item.addEventListener("click", (event) => {
                event.preventDefault();
                console.log(this.itemsMap.get(item));
                const targetSection = this.itemsMap.get(item);
                if (targetSection) {
                    this.scrollToSection(targetSection);
                } else {
                    console.error(`Section nicht gefunden: ${item}`);
                }
            });
        });
    }

    setActiveMenueItem(element) {
        this.menueItems.forEach((item) => {
            if (element === item) {
                item.setAttribute("data-menue-projekt", "aktiv");
            } else {
                item.removeAttribute("data-menue-projekt");
            }
        });
    }

    scrollToSection(section) {
        function getPaddingTopValue() {
            const width = window.innerWidth;
            const projektBeschriftung = document.querySelector('.projekt__beschriftung');
            const projektBeschriftungHeight = projektBeschriftung.offsetHeight;
            console.log(`height: ${projektBeschriftungHeight}`);

            if (width >= 768) {
                // ab TabletHoch
                return projektBeschriftungHeight;
            } else {
                // Smartphone
                return 147 + projektBeschriftungHeight;
            }
        }
        let paddingTopValueBau = getPaddingTopValue();
        console.log(`paddingTopValueBau: ${paddingTopValueBau}`);

        const konzeptDiv = document.querySelector("#konzept");
        const entstehungDiv = document.querySelector("#entstehung");

        // Wenn der Klick auf Bau geht, bleibt offsetTop 0, sonst gelten die untenstehenden if-Bedingungen
        let offsetTop = 0;

        if (section.matches('#entstehung')) {
            console.log(entstehungDiv)
            if (konzeptDiv && entstehungDiv) {
                offsetTop = konzeptDiv.offsetTop + paddingTopValueBau + this.horizontalScrollLength + konzeptDiv.clientHeight;
            } else if (entstehungDiv) {
                // Wenn nur "#entstehung" vorhanden ist
                offsetTop = entstehungDiv.offsetTop + paddingTopValueBau;
                console.log("Scrollen zu Entstehung: ", offsetTop);
            }
        } else if (section.matches('#konzept')) {
            if (konzeptDiv) {
                offsetTop = konzeptDiv.offsetTop + paddingTopValueBau;
            }
        }

        window.scrollTo({
            top: offsetTop,
            behavior: "smooth"
        });
    }
}